import { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import { supabase } from '../lib/supabase';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

interface Testimonial {
  id: string;
  content: string;
  image_url: string;
  is_featured: boolean;
}

const FALLBACK_TESTIMONIALS = [
  {
    id: '1',
    content: 'حقيقي الله يعطيك العافية والله فعلاً فيه معلومات كانت عندي بس ما كنت أعرف كيف أصيغها صح شكراً جداً على تعبك وتدقيقك في كل شيء سواء في السيرة الذاتية أو الكلام اللي بينضاف على لينكدان ❤️',
    image_url: 'https://qvbmufzjhrhlugblnmwj.supabase.co/storage/v1/object/public/testimonials/feedback1.jpg',
    is_featured: true
  },
  {
    id: '2',
    content: 'يعطيك العافية شغلك مرتب بصراحة يوم قريت السيرة الذاتية حسيت إنها نفس شغل اللي يشتغلون بمجالي لأن فيه أشياء كنت أبي أكتبها بس ما عرفت كيف ولقيتها هنا مكتوبة زي ما كنت ابغي',
    image_url: 'https://qvbmufzjhrhlugblnmwj.supabase.co/storage/v1/object/public/testimonials/feedback2.jpg',
    is_featured: true
  },
  {
    id: '3',
    content: 'شغلكم جداً احترافي ❤️ الله يعطيكم العافية ما قصرتم',
    image_url: 'https://qvbmufzjhrhlugblnmwj.supabase.co/storage/v1/object/public/testimonials/feedback3.jpg',
    is_featured: true
  },
  {
    id: '4',
    content: 'أول شي ألف شكر لك 🌹🌹🌹 شغلك رائع وما عليه كلام 👑 تقدر تعتبر هالكلام فيدباك ولو إن الشغل يتكلم عن نفسه',
    image_url: 'https://qvbmufzjhrhlugblnmwj.supabase.co/storage/v1/object/public/testimonials/feedback4.jpg',
    is_featured: true
  },
  {
    id: '5',
    content: 'أنا جدا شاكر و ممتن لكم 🙏🙏',
    image_url: 'https://qvbmufzjhrhlugblnmwj.supabase.co/storage/v1/object/public/testimonials/feedback5.jpg',
    is_featured: true
  }
];

export default function Testimonials() {
  const [testimonials, setTestimonials] = useState<Testimonial[]>(FALLBACK_TESTIMONIALS);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let mounted = true;

    async function fetchTestimonials() {
      try {
        const { data, error } = await supabase
          .from('testimonials')
          .select('*')
          .order('created_at', { ascending: false });

        if (error) {
          throw error;
        }

        if (mounted) {
          // If we got data from Supabase, use it; otherwise, keep using fallback data
          if (data && data.length > 0) {
            setTestimonials(data);
          }
          setError(null);
        }
      } catch (err) {
        console.error('Error fetching testimonials:', err);
        // Keep using fallback data if there's an error
        if (mounted) {
          setError(null); // Don't show error since we're using fallback data
        }
      } finally {
        if (mounted) {
          setLoading(false);
        }
      }
    }

    fetchTestimonials();

    return () => {
      mounted = false;
    };
  }, []);

  if (loading) {
    return (
      <section id="testimonials" className="py-24 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl font-bold text-center mb-16">آراء العملاء</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[1, 2, 3].map((i) => (
              <div key={i} className="animate-pulse bg-white rounded-2xl p-6 shadow-lg">
                <div className="w-full h-96 bg-gray-200 rounded-lg"></div>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }

  return (
    <section id="testimonials" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-4xl font-bold text-center mb-16">آراء العملاء</h2>
        <div className="relative">
          <Swiper
            modules={[Autoplay, Pagination, Navigation]}
            spaceBetween={30}
            slidesPerView={1}
            autoplay={{
              delay: 5000,
              disableOnInteraction: false,
            }}
            pagination={{
              clickable: true,
              dynamicBullets: true,
            }}
            navigation={true}
            breakpoints={{
              640: {
                slidesPerView: 2,
              },
              1024: {
                slidesPerView: 3,
              },
            }}
            className="testimonials-swiper pb-12"
          >
            {testimonials.map((testimonial) => (
              <SwiperSlide key={testimonial.id}>
                <div className="bg-white rounded-2xl shadow-lg overflow-hidden transform transition-transform duration-300 hover:scale-105">
                  <img
                    src={testimonial.image_url}
                    alt="رأي العميل"
                    className="w-full h-auto object-contain"
                    loading="lazy"
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
}